// extracted by mini-css-extract-plugin
export default {"linkWrapper":"Gfd890a","orderDetailsItem":"G45ce95","message":"G43876b"};